var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-progress',{attrs:{"type":"circle","percentage":_vm.percentage,"stroke-width":8,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }